import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { IconButton, Grid, Card, Tooltip } from "@material-ui/core";
import { getLocalizedString } from "@icarius-localization/strings";
import { DeleteIcon, FilterIcon } from "@icarius-icons";
import Form from "./form";
import { deletePermissionSettingsAction } from "../../actions";
import DataContainer from "@icarius-common/abmComponents/dataContainer";
import { openDialogAction } from "@icarius-common/dialog/actions";
import FilterDialog from "../filterDialog";

const Permission = (props) => {
  const [filterDialogIsOpen, setFilterDialogIsOpen] = useState(false);

  const { data, types, color, closeNewPublication } = props;
  const dispatch = useDispatch();

  const isCreate = !Boolean(data);

  const [isOpen, setIsOpen] = useState(isCreate); //si viene sin data, que este abierto por defecto

  const handleDeletePublication = () => {
    if (isCreate) {
      closeNewPublication();
    } else {
      dispatch(deletePermissionSettingsAction(data));
    }
  }

  const handleClosePublication = () => {
    Boolean(data) && setIsOpen(prev => !prev);
  }

  const getTypeName = () => {
    return types.filter(type => type.key === data.type)[0].value;
  }

  const handleOpenDeleteDialog = () => {
    dispatch(openDialogAction({
      title: getLocalizedString("permissionDeleteDialogTitle"),
      msg: getLocalizedString("confirmDeletePermission"),
      onConfirm: handleDeletePublication,
    }));
  }

  const getHasFilters = () => {
    return data?.sqlFilter;
  }


  return (
    <>
      <Card style={{ width: "100%", borderRadius: 10, background: (isOpen || isCreate) ? color : "", color: (isOpen || isCreate) && 'white' }}>
        <Grid container item xs={12} direction="row" style={{ padding: "10px 20px" }}>
          <Grid container item xs={11} style={{ cursor: Boolean(data) ? "pointer" : "" }} onClick={handleClosePublication}>
            {
              isCreate ?
                <DataContainer lg={12} sm={12} md={12} text={getLocalizedString("permissionCreation")} />
                :
                <>
                  <DataContainer sm={12} lg={2} md={2} text={data.code} />
                  <DataContainer sm={12} lg={5} md={5} text={data.name} />
                  <DataContainer sm={12} lg={5} md={5} text={getTypeName()} />
                </>
            }
          </Grid>
          <Grid container direction="row" item xs={1} justify="center">
            {
              !isCreate && <Tooltip title={getLocalizedString("filter")}>
                <IconButton size={"small"} disableRipple onClick={() => setFilterDialogIsOpen(true)}>
                  <FilterIcon style={{ fill: getHasFilters() ? color : "var(--mainText)", height: "15px" }} fontSize="small" />
                </IconButton>
              </Tooltip>
            }
            <Tooltip title={getLocalizedString("delete")}>
              <IconButton size={"small"} disableRipple onClick={handleOpenDeleteDialog}>
                <DeleteIcon style={{ fill: "var(--mainText)" }} fontSize="small" />
              </IconButton>
            </Tooltip>
          </Grid>
        </Grid>
      </Card>
      {
        isOpen &&
        <Form
          data={data}
          types={types}
          handleClose={isCreate ? closeNewPublication : handleClosePublication}
        />
      }
      {
        filterDialogIsOpen &&
        <FilterDialog
          open={filterDialogIsOpen}
          data={data}
          handleClose={() => setFilterDialogIsOpen(false)}
        />
      }
    </>
  );
}

export default Permission;
